function initializePostGalleries() {
  document.querySelectorAll('[data-post-gallery-editor]').forEach(editor => {
    if (editor.dataset.galleryInitialized === 'true') return;
    editor.dataset.galleryInitialized = 'true';

    const toggle = editor.querySelector('[data-gallery-toggle]');
    const panel = editor.querySelector('[data-gallery-panel]');
    const input = editor.querySelector('[data-gallery-files]');
    const titleInput = editor.querySelector('[data-gallery-title]');
    const total = editor.querySelector('[data-gallery-total]');
    const error = editor.querySelector('[data-gallery-error]');
    const maxImages = Number(editor.dataset.maxImages || 10);

    function keptExistingCount() {
      const removals = editor.querySelectorAll('[data-gallery-remove]:checked').length;
      return Math.max(Number(editor.dataset.existingCount || 0) - removals, 0);
    }

    function selectedFileCount() {
      return input && input.files ? input.files.length : 0;
    }

    function validateCount() {
      const count = keptExistingCount() + selectedFileCount();
      const valid = count <= maxImages;
      total.textContent = `${count}/${maxImages}`;
      total.classList.toggle('bg-danger', !valid);
      total.classList.toggle('text-white', !valid);
      total.classList.toggle('bg-light', valid);
      total.classList.toggle('text-dark', valid);
      input.setCustomValidity(valid ? '' : `Cada galería admite hasta ${maxImages} imágenes.`);
      input.classList.toggle('is-invalid', !valid);
      error.textContent = valid ? '' : `Seleccionaste ${count}. El máximo permitido es ${maxImages}.`;
    }

    function syncEnabledState(updateRemovals) {
      const enabled = toggle.checked;
      panel.hidden = !enabled;
      toggle.setAttribute('aria-expanded', String(enabled));
      input.disabled = !enabled;
      titleInput.required = enabled;
      if (!enabled) {
        input.value = '';
      }
      if (updateRemovals) {
        editor.querySelectorAll('[data-gallery-remove]').forEach(checkbox => {
          checkbox.checked = !enabled;
        });
      }
      validateCount();
    }

    toggle.addEventListener('change', () => syncEnabledState(true));
    input.addEventListener('change', validateCount);
    editor.querySelectorAll('[data-gallery-remove]').forEach(checkbox => {
      checkbox.addEventListener('change', validateCount);
    });
    syncEnabledState(false);
  });
}

document.addEventListener('turbolinks:load', initializePostGalleries);
document.addEventListener('DOMContentLoaded', initializePostGalleries);
